import "./CountrySpecific.scss";

import React from "react";
import { Container } from "../../../../../../components/Grid/Grid";
import { Typography } from "../../../../../../components/__common/Typography/Typography";
import { SVG_ICONS } from "../../../../../../components/__common/Svg/Svg";
import { Button } from "../../../../../../components/__common/_controls";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../../../../configs/routes";
import PrivacyInfoCarousel from "../Carousels/PrivacyInfoCarousel/PrivacyInfoCarousel";
import { UtilsUser } from "../../../../../../utils/UtilsUser";
import CountryCarousel from "../Carousels/CountryCarousel/CountryCarousel";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../store";
import { MyDataState } from "../../../../../../store/reducers/mydata-reducer";
import { useTranslation } from "react-i18next";

interface Props {
  setModalOpen: (value: boolean) => void;
  hasLocalSite: boolean;
  // NOTE: Temporary only as Europe countries have no local sites yet
  isEuropeCountry: boolean;
}

const CountrySpecific: React.FC<Props> = ({
  setModalOpen,
  hasLocalSite,
  isEuropeCountry,
}) => {
  const historyHook = useHistory();
  const { history } = useSelector<ApplicationState, MyDataState>(
    (state) => state.myData
  );
  const { t } = useTranslation();

  return (
    <Container className="country-specific">
      <Container>
        <Typography variant="h1" className="country-specific__title">
          {t("PRIVACY_HOME_SAMSUNG_PRIVACY POLICY")}
        </Typography>
      </Container>

      {UtilsUser.isUserLoggedIn() && hasLocalSite && !isEuropeCountry ? (
        <CountryCarousel setModalOpen={setModalOpen} />
      ) : (
        <PrivacyInfoCarousel />
      )}

      <Container className="country-specific__your-rights">
        <Typography
          variant="title1"
          className="country-specific__your-rights__title"
        >
          {UtilsUser.isUserLoggedIn() &&
          history.request_count > 0 &&
          hasLocalSite &&
          !isEuropeCountry
            ? t("PRIVACY_HUB_PREVREQUESTS_TITLE")
            : t("PRIVACY_HUB_YOURRIGHTS_TITLE")}
        </Typography>
        {UtilsUser.isUserLoggedIn() &&
        history.request_count > 0 &&
        hasLocalSite &&
        !isEuropeCountry ? (
          <>
            <Typography
              variant="body1"
              weight="w500"
              className="country-specific__your-rights__desc"
            >
              {t("PRIVACY_HUB_PREVREQUESTS_TEXT1")}
            </Typography>
            <Typography
              variant="body1"
              weight="w500"
              className="country-specific__your-rights__desc"
            >
              {t("PRIVACY_HUB_PREVREQUESTS_TEXT2")}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant="body1"
              weight="w500"
              className="country-specific__your-rights__desc"
            >
              {t("PRIVACY_HUB_YOURRIGHTS_TEXT1")}
            </Typography>
            <Typography
              variant="body1"
              weight="w500"
              className="country-specific__your-rights__desc"
            >
              {t("PRIVACY_HUB_YOURRIGHTS_TEXT2")}
            </Typography>
          </>
        )}
        <Button
          title={
            UtilsUser.isUserLoggedIn() &&
            history.request_count > 0 &&
            hasLocalSite &&
            !isEuropeCountry
              ? t("PRIVACY_HUB_PREVREQUESTS_BTN_REQHISTIRY")
              : t("PRIVACY_HUB_YOURRIGHTS_BTN_MYDATA")
          }
          className="country-specific__your-rights__button"
          icon={SVG_ICONS.ARROW_RIGHT}
          iconPosition="right"
          onClick={() =>
            historyHook.push(
              UtilsUser.isUserLoggedIn() &&
                history.request_count > 0 &&
                hasLocalSite
                ? ROUTES.MYDATA_HISTORY
                : ROUTES.MYDATA
            )
          }
          type="content"
        />
      </Container>
    </Container>
  );
};

export default CountrySpecific;
